module.exports = global["$"] = require("-!F:\\agent2\\_work\\3\\s\\Olympic\\Olympic.Trader.Website\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js-exposed
 ** module id = 2
 ** module chunks = 9
 **/